import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { Audience } from '../models/Audience'
import { AUDIENCES_URL, LOYALTY_TIERS_URL } from '../utils/urls'

const fetchAudiences = (params: TableParams) =>
  SBAPI.FetchPaginated<Audience[]>(AUDIENCES_URL, params)

const fetchAudienceById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Audience>(`${AUDIENCES_URL}/${id}`, params)

/**
 * Get the number of users in a loyalty tier
 *
 * Without params, this returns the total number of users in the tier, whether they are subscribed to notification or not.
 * By passing `subscribed_to_notification` with any value, it returns only the number of users subscribed to notifications.
 */
const fetchUsersByLoyaltyTier = (
  loyaltyTier: number,
  params?: { subscribed_to_notification?: true }
) =>
  SBAPI.Fetch<{ users: number }>(
    `${LOYALTY_TIERS_URL}/${loyaltyTier}/users`,
    params
  )

const createAudience = (audience: Audience) =>
  SBAPI.Post(AUDIENCES_URL, audience)

const updateAudience = (audience: Audience) =>
  SBAPI.Put(`${AUDIENCES_URL}/${audience.id}`, audience)

const deleteAudience = (audience: Audience) =>
  SBAPI.Delete(`${AUDIENCES_URL}/${audience.id}`)

export {
  createAudience,
  deleteAudience,
  fetchAudienceById,
  fetchAudiences,
  fetchUsersByLoyaltyTier,
  updateAudience,
}
